import { getInstance } from '../instance';
import { buildMldCountsQuery, buildMldListQuery } from './query';
import {
  MldCountsParams,
  MldCountsResponse,
  MldDetailResponse,
  MldListParams,
  MldListResponse,
  MldMemberResponse,
} from './types';

/**
 * The native Member List Deal read routes (ADR-007). They are versioned
 * (`/v1/abo/mld...`), so the paths are RELATIVE to the shared `dsInstance`,
 * whose baseURL already carries `/v1` (same pattern as
 * `api/memberCredits/actions.ts`). Read-only: there is no MLD write route.
 * Failures propagate unchanged; the page maps a 404 `code` to its state.
 */
export const MLD_PATH = 'abo/mld';
export const MLD_COUNTS_PATH = `${MLD_PATH}/counts`;
export const MLD_SUBSCRIPTIONS_PATH = `${MLD_PATH}/subscriptions`;
export const MLD_MEMBER_PATH = `${MLD_PATH}/member`;

const instance = getInstance();

/** One page of deals; `params.page` is the 1-based UI page. */
export const fetchMldDeals = async (
  params: MldListParams = {},
): Promise<MldListResponse> => {
  const { data } = await instance.get<MldListResponse>(MLD_PATH, {
    params: buildMldListQuery(params),
  });
  return data;
};

/** The tab pills: the list filters without status and paging. */
export const fetchMldCounts = async (
  params: MldCountsParams = {},
): Promise<MldCountsResponse> => {
  const { data } = await instance.get<MldCountsResponse>(MLD_COUNTS_PATH, {
    params: buildMldCountsQuery(params),
  });
  return data;
};

/** One deal by Chargebee subscription id, with the member's other deals. */
export const fetchMldDeal = async (
  subscriptionId: string,
): Promise<MldDetailResponse> => {
  const { data } = await instance.get<MldDetailResponse>(
    `${MLD_SUBSCRIPTIONS_PATH}/${encodeURIComponent(subscriptionId)}`,
  );
  return data;
};

/** Every deal of one DS customer; `deals` is empty when there is none. */
export const fetchMldMemberDeals = async (
  customerId: string,
): Promise<MldMemberResponse> => {
  const { data } = await instance.get<MldMemberResponse>(
    `${MLD_MEMBER_PATH}/${encodeURIComponent(customerId)}`,
  );
  return data;
};
